import React, { useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import useFollowUser from "../hooks/useFollowUser";
import useModalStore from "../StatesStore/ModalStore";
import useNotification from "../hooks/useNotification";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";

const CheckFollow = ({ myData, friendData, componentName }) => {
  // console.log("myData", myData);
  const {
    loading,
    isFollowed,
    isFollowBack,
    followUser,
    unfollowUser,
  } = useFollowUser(
    myData?.uid,
    componentName === "UserProfileCard" ? friendData?.objectID : friendData?.uid
  );
  const { openModal } = useModalStore();
  const { deleteNotification } = useNotification();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const unfollowFunction = async (friendUID) => {
    try {
      await unfollowUser();
      await deleteNotification({
        userId: friendUID,
        id: myData?.uid,
        type: "followed",
        by: "user",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to unfollow user", toastOptions);
    }
  };

  const handleClick = () => {
    if (!myData) {
      openModal("SignInModal", "", "");
    } else if (!myData?.emailVerified) {
      openModal("VerifyEmailModal", "", {
        userName: myData?.displayName,
        email: myData?.providerData[0]?.email,
      });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return componentName === "UserProfileCard" ? (
    <div
      onClick={
        !loading && myData?.emailVerified
          ? isFollowed
            ? () => unfollowFunction(friendData?.uid)
            : followUser
          : handleClick
      }
      className="d-flex align-items-center justify-content-center"
      style={{
        width: isFollowBack ? "80%" : "70%",
        height: "31px",
        gap: "10px",
        borderRadius: "8px",
        borderWidth: "1px",
        cursor: "pointer",
        backgroundColor: isFollowed ? "#F4F4F4" : "#F4F9FF",
      }}
    >
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "500",
          fontSize: "14px",
          lineHeight: "100%",
          letterSpacing: "0%",
          textAlign: "center",
          color: isFollowed ? "#676A79" : "#005FDA",
        }}
      >
        {loading ? (
          <LoadingSpinner spinnerSize="14px" />
        ) : isFollowed ? (
          "Following"
        ) : isFollowBack ? (
          "Follow Back"
        ) : (
          "Follow"
        )}
      </div>
    </div>
  ) : componentName !== "ProfilePage" ? (
    <div
      onClick={
        !loading && myData?.emailVerified
          ? isFollowed
            ? () => unfollowFunction(friendData?.uid)
            : followUser
          : handleClick
      }
      className="d-flex align-items-center justify-content-center"
      style={{
        width: isSmallScreen ? "100px" : isFollowBack ? "135px" : "114px",
        height: isSmallScreen ? "30px" : "40px",
        gap: "10px",
        borderRadius: isSmallScreen ? "0.5rem" : "10px",
        borderWidth: "1px",
        cursor: "pointer",
        backgroundColor: isFollowed ? "#F4F4F4" : "#F4F9FF",
      }}
    >
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "500",
          fontSize: isSmallScreen ? "14px" : "18px",
          lineHeight: "100%",
          letterSpacing: "0%",
          textAlign: "center",
          color: isFollowed ? "#676A79" : "#005FDA",
        }}
      >
        {loading ? (
          <LoadingSpinner spinnerSize="14px" />
        ) : isFollowed ? (
          "Following"
        ) : isFollowBack ? (
          "Follow Back"
        ) : (
          "Follow"
        )}
      </div>
    </div>
  ) : isSmallScreen ? (
    <div
      style={{
        borderRadius: "8px",
        width: "100%",
        height: "32px",
        backgroundColor: isFollowed ? "#F4F4F4" : "#F4F9FF",
        cursor: "pointer",
        borderWidth: "1px",
      }}
      className="d-flex align-items-center justify-content-center"
      onClick={
        !loading && myData?.emailVerified
          ? isFollowed
            ? () => unfollowFunction(friendData?.uid)
            : followUser
          : handleClick
      }
    >
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "100%",
          letterSpacing: "0%",
          color: isFollowed ? "#676A79" : "#005FDA",
        }}
      >
        {loading ? (
          <LoadingSpinner spinnerSize="14px" />
        ) : isFollowed ? (
          "Following"
        ) : isFollowBack ? (
          "Follow Back"
        ) : (
          "Follow"
        )}
      </div>
    </div>
  ) : (
    <div
      style={{
        width: isFollowBack ? "135px" : "114px",
        height: "42px",
        backgroundColor: isFollowed ? "#F4F4F4" : "#F4F9FF",
        cursor: "pointer",
        borderRadius: "12px",
        borderWidth: "1px",
      }}
      className="d-flex align-items-center justify-content-center"
      onClick={
        !loading && myData?.emailVerified
          ? isFollowed
            ? () => unfollowFunction(friendData?.uid)
            : followUser
          : handleClick
      }
    >
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "18px",
          lineHeight: "100%",
          letterSpacing: "0%",
          color: isFollowed ? "#676A79" : "#005FDA",
        }}
      >
        {loading ? (
          <LoadingSpinner spinnerSize="18px" />
        ) : isFollowed ? (
          "Following"
        ) : isFollowBack ? (
          "Follow Back"
        ) : (
          "Follow"
        )}
      </div>
    </div>
  );
};

export default CheckFollow;
